import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { BaseTable, BaseMobileTable } from 'ui-kit';
import useWindowDimensions from '../../hooks/useWindowDimensions';

function TableWrapper({
  columns,
  data,
  isEdit,
  tableControlParams,
  editCellParams,
  checkboxCellParams,
  tableVievModeButtonName,
  getTrPropsFunctions,
  isManageAssignmentsTable,
  isMapAssignments,
}) {
  const { width: viewportWidth } = useWindowDimensions();

  return (
    <>
      {viewportWidth >= 900 || isMapAssignments ? (
        <BaseTable isEdit={isEdit} columns={columns} data={data} getTrPropsFunctions={getTrPropsFunctions} />
      ) : (
        <BaseMobileTable
          isEdit={isEdit}
          columns={columns}
          data={data}
          tableControlParams={tableControlParams}
          editCellParams={editCellParams}
          checkboxCellParams={checkboxCellParams}
          tableVievModeButtonName={tableVievModeButtonName}
          isManageAssignmentsTable={isManageAssignmentsTable}
        />
      )}
    </>
  );
}

TableWrapper.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  editCellParams: PropTypes.object,
  tableControlParams: PropTypes.object.isRequired,
  isEdit: PropTypes.bool,
  checkboxCellParams: PropTypes.object,
  tableVievModeButtonName: PropTypes.string,
  getTrPropsFunctions: PropTypes.object,
  isManageAssignmentsTable: PropTypes.bool,
  isMapAssignments: PropTypes.bool,
};

TableWrapper.defaultProps = {
  isEdit: false,
  checkboxCellParams: {},
  getTrPropsFunctions: {},
  tableVievModeButtonName: '',
  isManageAssignmentsTable: false,
  isMapAssignments: false,
  editCellParams: {},
};

export default memo(TableWrapper);
